import { render, staticRenderFns } from "./item-wrap-def.vue?vue&type=template&id=ae21af7c&scoped=true"
import script from "./item-wrap-def.vue?vue&type=script&lang=js"
export * from "./item-wrap-def.vue?vue&type=script&lang=js"
import style0 from "./item-wrap-def.vue?vue&type=style&index=0&id=ae21af7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae21af7c",
  null
  
)

export default component.exports